import {
    Box, Button, TextField, Grid,
    Select, MenuItem, FormControl, InputLabel,
    Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { btnSx, inputSx } from './adminConstants';

// Dialog: Neue Übung anlegen (Admin).
function UebungDialog({ open, onClose, formData, onInputChange, formErrors, onSubmit }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
            PaperProps={{ sx: { borderRadius: '16px', background: '#1e293b', border: '1px solid rgba(59,130,246,0.2)' } }}>
            <DialogTitle sx={{ color: '#f1f5f9', fontWeight: 500, pb: 1 }}>Neue Übung hinzufügen</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField label="Name" name="name" value={formData.name}
                        onChange={onInputChange} error={!!formErrors.name} helperText={formErrors.name} fullWidth required sx={inputSx} />
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <TextField label="Zielmuskel" name="zielmuskel" value={formData.zielmuskel}
                                onChange={onInputChange} error={!!formErrors.zielmuskel} helperText={formErrors.zielmuskel} fullWidth required sx={inputSx} />
                        </Grid>
                        <Grid size={6}>
                            <FormControl fullWidth error={!!formErrors.kategorie} required sx={inputSx}>
                                <InputLabel>Kategorie</InputLabel>
                                <Select name="kategorie" value={formData.kategorie} onChange={onInputChange} label="Kategorie">
                                    {['Push', 'Pull', 'Beine', 'Core'].map(k => <MenuItem key={k} value={k}>{k}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <TextField label="Beschreibung" name="beschreibung" value={formData.beschreibung}
                        onChange={onInputChange} error={!!formErrors.beschreibung} helperText={formErrors.beschreibung}
                        fullWidth required multiline rows={3} sx={inputSx} />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                <Button onClick={onClose} sx={{ color: '#94a3b8', textTransform: 'none' }}>Abbrechen</Button>
                <Button onClick={onSubmit} variant="contained" startIcon={<FitnessCenterIcon />} sx={{ ...btnSx, padding: '9px 20px' }}>
                    Hinzufügen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UebungDialog;
